import { Settings } from "lucide-react";

const processes = [
  "3D Printing", "CNC Machining", "Laser Cutting", "PCB Manufacturing",
  "Electronics Assembly", "Injection Moulding", "Sheet Metal", "Welding",
  "Robotics", "Composites",
];

export default function ManufacturingProcessStep({ formData, updateField }) {
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {processes.map((process) => {
        const isSelected = formData.process === process;
        return (
          <button
            key={process}
            type="button"
            onClick={() => updateField("process", process)}
            className={`flex items-center gap-3 px-5 py-4 rounded-xl border font-semibold text-sm transition ${
              isSelected
                ? "bg-gradient-to-r from-indigo-600 to-blue-500 border-transparent text-white"
                : "bg-white border-gray-200 text-gray-800 hover:border-indigo-300"
            }`}
          >
            <Settings className={`w-4 h-4 ${isSelected ? "text-white" : "text-blue-500"}`} />
            {process}
          </button>
        );
      })}
    </div>
  );
}